import { render, staticRenderFns } from "./NewStoryForm.vue?vue&type=template&id=54e9ae10"
import script from "./NewStoryForm.vue?vue&type=script&lang=js"
export * from "./NewStoryForm.vue?vue&type=script&lang=js"
import style0 from "./NewStoryForm.vue?vue&type=style&index=0&id=54e9ae10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports